<div id="content" class="content">
    <div id="container" class="container">
      <div class="btnBackContainer">
        <button class="btnImage btnBack" (click)="voltar($event)">
          <img id="imgCamera" src="assets/img/document/btnBack.png" />
        </button>
      </div>
      <div class="outer r4x3">
        <div class="inner">
          <div *ngIf="!showTypeCapture && !showUpload" class="bgOverlay"></div>
          <div *ngIf="rotateCamera" class="cameraRotate">    
            <div id="divMsg">          
              <span id="spanMsg">Vire o celular</span>
            </div>      
            <img src="assets/img/document/rotate-device.png" />
          </div>
          <div *ngIf="!showTypeCapture && !processing" class="btnBackContainer">
            <!-- <button class="btnImage btnBack" (click)="backSetTypeCapture()"> --->
            <button class="btnImage btnBack" (click)="voltar($event)">
              <img id="imgCamera" src="assets/img/document/btnBack.png" />
            </button>
          </div>
         <!--  <div *ngIf="showTypeCapture" class="captureTypeBox">
             <button (click)="setTypeCapture(1)" class="btnImage fadeIn left">
              <img id="imgCamera" src="assets/img/document/btnType1.png" />
            </button>  
            <button (click)="setTypeCapture(2)" class="btnImage fadeIn right">
              <img id="imgCamera" src="assets/img/document/btnType2.png" />
            </button>
            <div class="msgStatic">           
              <span>Informe como vai capturar a imagem do seu documento.</span>
            </div>
          </div> -->
  
          <div *ngIf="!showTypeCapture" id="content-video" class="content-video" [class.contentDesktop]="showDesktop">
            <div class="containerVideo" [class.fullDesktop]="showUpload && showDesktop">
              <div id="divMsg">
                <span id="spanMsg">{{ message }}</span>
              </div>
              <div id="divLoader" *ngIf="isLoaded">
                <img src="assets/img/document/loading.svg" />
              </div>
              <div *ngIf="!showTypeCapture && !rotateCamera" id="overlay" class="overlay">
              </div>
              <video *ngIf="!showUpload" id="player">           
              </video>
              <div *ngIf="snapTempDOM !== ''" class="thumbPicture">
                <img id="imgCamera" [src]="snapTempDOM" />                
              </div>
              <div *ngIf="showUpload && !rotateCamera" class="thumbsGroup">
                <div *ngFor="let snap of snapsCaptures; let i = index" class="thumbGroupCard">
                  <img id="imgCamera" [src]="snap.data" />
                  <button (click)="removeSnapFromLists(i)" class="btnImage fadeIn left">
                    <img id="imgCamera" src="assets/img/document/btnChange.png" />
                  </button>
                </div>
              </div>
  
              <div *ngIf="uploadRequest" class="respUpload">
                <img *ngIf="uploadResp" id="imgCamera" src="assets/img/document/btnUploadSuccess.png" />
                <!-- <img *ngIf="!uploadResp" id="imgCamera" src="assets/img/document/btnUploadError.png" /> -->
                <div id="uploadMsg">
                  <span id="spanMsg">{{ message }}</span>
                </div>
              </div>
            </div>
            <div class="btnControllers" *ngIf="btnControllers">
              <button (click)="snapTick()" class="btnImage fadeIn left">
                <img id="imgCamera" src="assets/img/document/btnUsePicture.png" />
              </button>
              <button (click)="resetSnap()" class="btnImage fadeIn right">
                <img id="imgCamera" src="assets/img/document/btnNewPicture.png" />
              </button>
          </div>
          <div *ngIf="rotateCamera === false" id="divButton">
            <button id="btnIniciar" *ngIf="showIniciar && !btnControllers && !showUpload" (click)="startCapture()" class="btnImage btnCapture fadeIn">
              <img id="imgCamera" src="assets/img/document/btnCapture.png" />
            </button>
            <button *ngIf="showUpload && !uploadRequest" (click)="uploadPictures()" class="btnImage btnUpload fadeIn" [disabled]="isLoaded" [class.disabled]="isLoaded">
              <img id="imgCamera" src="assets/img/document/btnUpload.png" />
            </button>
          </div>   
          </div>      
        </div>
      </div>
      <notifier-container></notifier-container>  
    </div>
  </div>
  <canvas id="fc_canvas" style="display: none"></canvas>